import { render } from "./SuccessItem.vue?vue&type=template&id=50de159c&scoped=true&ts=true"
import script from "./SuccessItem.vue?vue&type=script&lang=ts"
export * from "./SuccessItem.vue?vue&type=script&lang=ts"

import "./SuccessItem.vue?vue&type=style&index=0&id=50de159c&scoped=true&lang=css"

import exportComponent from "/builds/custom-client/enablewa-token-refresher/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50de159c"]])

export default __exports__